import { PatientInformation } from "~/patients/utils/types";
import { PATIENT_STATUS } from "../constants";
import { PatientStatus } from "./types";

export const isPatientActive = (patientStatus?: PatientStatus) => {
  if (patientStatus === undefined) return false;
  return patientStatus === PATIENT_STATUS.active;
};

export const isPatientVerified = (patient: PatientInformation) => {
  return Boolean(patient.phone_number?.verified_at);
};
